import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Checkbox, Flex, IconButton, Text } from '@raystack/apsara';
import { Modal } from '@studio/components';

import { handleSatelliteCheck } from '@src/utils/AoiUtils';

export const Satellite = ({ constellation, info }) => {
  const dispatch = useDispatch();
  const [showSatInfo, setShowSatInfo] = useState(false);
  const filters = useSelector(state => state.filters);

  const handleCheckboxChange = checked => {
    handleSatelliteCheck(checked, constellation, filters, dispatch);
  };

  return (
    <Flex justify='between' align='center'>
      <Flex gap='small' align='center'>
        <Checkbox
          id={constellation.id}
          checked={filters?.satellite?.some(
            i => i.satellite_id === constellation.id
          )}
          onCheckedChange={handleCheckboxChange}
        />
        <Text size={2}>{constellation.name}</Text>
      </Flex>

      {info && info.show && (
        <>
          <IconButton
            size={3}
            onClick={() => setShowSatInfo(true)}
            data-test-id='d2-info-btn'
          >
            <InfoCircledIcon
              style={{ color: 'var(--rs-color-foreground-base-secondary)' }}
            />
          </IconButton>

          <Modal
            show={showSatInfo}
            onClose={() => setShowSatInfo(false)}
            title={constellation.name}
            width={464}
          >
            {info.description}
          </Modal>
        </>
      )}
    </Flex>
  );
};
